<div class="ops-checkbox-container" [class.disabled]="isDisabled">
  <label *ngIf="label" class="ops-input-label">{{ label }}</label>

  <!-- <div *ngIf="isPreview" class="ops-input preview">
    <span>{{ value ? 'On' : 'Off' }}</span>
  </div> -->

  <label class="switch" *ngIf="!isPreview">
    <input
      type="checkbox"
      [checked]="value"
      [disabled]="isDisabled"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (click)="onClick()"
      (change)="onChange($event)"
    />
    <span class="slider"></span>
  </label>

  <label class="switch disabled" *ngIf="isPreview">
    <input type="checkbox" readonly disabled [checked]="value" />
    <span class="slider"></span>
  </label>

  <span *ngIf="noteText && !isPreview" class="ops-input-note">{{
    noteText
  }}</span>
</div>
